"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get down () {
        return down;
    },
    get up () {
        return up;
    }
});
const _globals = require("~/utils/globals");
const up = async (knex)=>{
    await knex.schema.alterTable(_globals.MetaTable.DEPENDENCY_TRACKER, (table)=>{
        // Queryable fields (indexed) - for fields used in WHERE clauses
        // queryable_field_0: Workflow=nodeType (e.g., "nocodb.trigger.after_insert")
        // queryable_field_1: Reserved for future queryable needs
        table.text('queryable_field_0');
        table.text('queryable_field_1');
        // Meta field (not indexed) - JSON storage for display/reference data
        table.text('meta');
    });
    // Add indexes only on queryable fields
    await knex.schema.alterTable(_globals.MetaTable.DEPENDENCY_TRACKER, (table)=>{
        if (![
            'mysql',
            'mysql2'
        ].includes(knex.client.config.client)) {
            table.index('queryable_field_0', 'nc_dependency_tracker_queryable_field_0_idx');
            table.index('queryable_field_1', 'nc_dependency_tracker_queryable_field_1_idx');
        }
    });
};
const down = async (knex)=>{
    // Drop indexes first
    await knex.schema.alterTable(_globals.MetaTable.DEPENDENCY_TRACKER, (table)=>{
        table.dropIndex('queryable_field_0', 'nc_dependency_tracker_queryable_field_0_idx');
        table.dropIndex('queryable_field_1', 'nc_dependency_tracker_queryable_field_1_idx');
    });
    // Then drop columns
    await knex.schema.alterTable(_globals.MetaTable.DEPENDENCY_TRACKER, (table)=>{
        table.dropColumn('queryable_field_0');
        table.dropColumn('queryable_field_1');
        table.dropColumn('meta');
    });
};
